import { render, staticRenderFns } from "./Attitudes.vue?vue&type=template&id=1e551441&"
import script from "./Attitudes.vue?vue&type=script&lang=js&"
export * from "./Attitudes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports